{
  "es": {
    "modal": {
      "actions": {
        "add": "Asignar este cliente a esta unidad",
        "approve": "Aprobar",
        "assign": "Asignar a esta unidad",
        "assign_SUP": "Asignar a este proyecto",
        "block": "Bloquear",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "contact_ziggu": "Contactar con Ziggu",
        "giveAccess": "Dar acceso online",
        "goBack": "Volver",
        "gotIt": "Entendido",
        "loading": "Cargando",
        "next": "Siguiente",
        "no": "No",
        "remove": "Eliminar",
        "select_rights": "Seleccionar permisos",
        "send": "Enviar invitación por correo",
        "sendFeedback": "Enviar comentarios",
        "skip": "Omitir",
        "submit": "Guardar",
        "submitting": "Guardando",
        "uploading": "Subiendo",
        "yes": "Sí"
      },
      "labels": {
        "areYouSure": "¿Estás seguro?",
        "areYouSureDelete": "¿Estás seguro de que quieres eliminar {object}?",
        "assignCustomerToUnitMessagePermanently": "{customer} ya ha sido invitado a la plataforma. Al asignar esta unidad, tendrá acceso inmediato.",
        "assignCustomerToUnitTitlePermanently": "¿Asignar {customer} de forma permanente a {unit}?",
        "assignTodoListToLevel": "Estás a punto de asignar la lista de tareas {object} al nivel {level}. ¿Continuar?",
        "dangerZone": "Zona de peligro",
        "deleteCustomerMessage": "Esta persona perderá todo el acceso a la plataforma y, por tanto, todos los documentos, preguntas frecuentes, conversaciones, novedades, etc.",
        "deleteCustomerTitle": "¿Estás seguro de que quieres eliminar al cliente {customer}?",
        "deleteDecisionsBulk": "¿Estás seguro de que quieres eliminar {amount} decisiones?",
        "deleteDeniedMessage": "Este cliente tiene al menos 1 unidad asignada. Quita primero estas unidades asignadas antes de eliminar a este cliente.",
        "deleteDeniedTitle": "No se permite eliminar a {customer}",
        "deleteEmployeeSubMessage": "Desactiva a este usuario en su lugar si quieres conservar toda su información.",
        "deleteEmployeeTitle": "¿Estás seguro de que quieres eliminar a {employee}?",
        "deleteLeadMessage": "Si este interesado estaba interesado en una unidad, perderás estos datos. Si había comprado una unidad y se convirtió en cliente, conservarás al cliente y sus datos.",
        "deleteLeadTitle": "¿Estás seguro de que quieres eliminar al interesado {lead}?",
        "goToProposal": "Ir a {proposal_name}",
        "gotItMessage": "Vale, entendido",
        "loading": "El archivo se está subiendo, espera un momento. La pantalla de subida se cerrará automáticamente.",
        "noUnitSelected": "¡Vaya! No se ha seleccionado ninguna unidad",
        "noUnitSelectedMessage": "Selecciona la unidad sobre la que quieres notificar una incidencia",
        "notPossible": "No es posible",
        "ohNo": "¡Oh, no!",
        "removeCustomerDeleteInfo1": "Se eliminarán las conversaciones en las que participó el cliente",
        "removeCustomerDeleteInfo2": "Se eliminarán las encuestas relacionadas con esta unidad",
        "removeCustomerDeleteInfo3": "Se eliminarán los documentos subidos por el cliente en conversaciones, decisiones o propuestas. Esto también incluye las versiones firmadas de los documentos.",
        "removeCustomerKeepInformation": "Los documentos generales y cualquier otro contenido publicado en esta unidad permanecerán sin cambios y serán visibles para un nuevo cliente.  ",
        "removeCustomerMessage": "{customer} ha tenido acceso completo a esta unidad. Si eliminas al cliente, se eliminará todo el contenido de {customer}. Esto significa… ",
        "removeCustomerMessageNth": "Si eliminas a este cliente, el contenido creado por {customer} se desvinculará de {customer}. Esto significa que el contenido se conservará, pero ya no procederá de {customer}.",
        "removeMessage": "¿Estás seguro de que quieres eliminar {level}? Al hacerlo, perderás todos los datos guardados relacionados con este {type}. No podrás recuperarlos después.",
        "removeTitle": "Eliminar {record_name}",
        "revokeAccessMessage": "Estás a punto de revocar el acceso de {customer} a esta unidad. Si esta es la única unidad asignada al cliente, perderá el acceso completo a la plataforma. ",
        "setCustomerMessage": "¡Genial! Estás a punto de asignar {customer} a {unit}. {customer} aún no tendrá acceso completo a la plataforma. Pero puedes cambiar eso concediendo acceso una vez que hayas asignado esta unidad. ",
        "setCustomerMessageSUP": "¡Genial! Estás a punto de asignar {customer} a {unit}. {customer} aún no tendrá acceso completo a la plataforma. Pero puedes cambiar eso concediendo acceso una vez que hayas asignado este proyecto. ",
        "setCustomerTitle": "¿Asignar {customer} a {unit}?",
        "setVisibleMessage": "¡Estupendo! Estás a punto de dar a {customer} acceso completo a los documentos compartidos y la información relacionada con {unit}. ",
        "setVisibleTitle": "¿Dar a {customer} acceso online a {unit}?",
        "this": "esto",
        "typeHere": "Escribe aquí...",
        "typeToConfirm": "Escribe «{confirmationInput}» para confirmar",
        "warningAreYouSure": "¡CUIDADO! ¿Estás seguro?",
        "warningDeleteDocument": "{file_name} se subió en un {attachable_type}. Eliminarlo aquí también lo eliminará del {attachable_type}",
        "warningDeleteDocumentApprovedProposal": "{file_name} es un documento que pertenece a una propuesta aprobada y no se puede eliminar en este estado. Eliminarlo requeriría revertir la aprobación de la propuesta",
        "warningDeleteDocumentLevel": "{file_name} se subió en la carpeta {level_type}. Eliminarlo aquí también lo eliminará de la carpeta {level_type}",
        "warningDeleteDocumentMulti": "Algunos de los documentos que quieres eliminar se subieron en una decisión o una conversación. Eliminarlos aquí también los eliminará de la decisión o la conversación"
      }
    }
  }
}
